import { RadioButton } from '@uikit';

import type { HotOffersFilterValue } from '@api';
import { HOT_OFFERS_FILTER } from '@api';

import { useAuth } from '@shared/common/providers/AuthProvider';

export interface HotOffersFiltersProps {
  filterBy: HotOffersFilterValue;
  onFilterByChange: (value: HotOffersFilterValue) => void;
}

const filterOptions = [
  {
    label: 'New',
    value: HOT_OFFERS_FILTER.NEW,
  },
  {
    label: 'Unclaimed',
    value: HOT_OFFERS_FILTER.UNCLAIMED,
  },
  {
    label: 'Claimed',
    value: HOT_OFFERS_FILTER.CLAIMED,
  },
];

export default function HotOffersFilters({ filterBy, onFilterByChange }: HotOffersFiltersProps) {
  const { isAuth } = useAuth();
  const filterOptionsVisible = [
    {
      label: 'All',
      value: HOT_OFFERS_FILTER.ALL,
      isVisible: true,
    },
    ...(isAuth ? filterOptions : []),
  ];

  return (
    <div className="w-full flex flex-col flex-grow flex-wrap gap-4 mb-5 sm:flex-row">
      <p className="t-button">Filter by:</p>

      <div className="flex flex-grow flex-wrap gap-4">
        {filterOptionsVisible.map(({ label, value }) => {
          return (
            <RadioButton
              key={value}
              name="mode"
              label={label}
              checked={filterBy === value}
              value={value}
              onChange={() => onFilterByChange(value)}
              indicatorClassName="text-secondary-600"
              labelClassName="t-caption1 text-neutral-500"
            />
          );
        })}
      </div>
    </div>
  );
}
